import styled from '@emotion/styled'

export default styled.h2`
  text-align: center;
  font-family: monospace;
  flex-basis: 30%;
`